import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as siteInfoActions from './../../../../actions/siteInfoAction';
import SiteInfo from './SiteInfo';

const mapStateToProps = state => {
    return {
        siteInfoState: state.siteInfoReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListSiteInfos: (filters) => dispatch(siteInfoActions.getListSiteInfo(filters)),
        deleteSiteInfoDetail: (siteinfo, filters) => dispatch(siteInfoActions.deleteSiteInfoDetail(siteinfo, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SiteInfo));
